import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 23 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      stroke: "#000",
      "stroke-width": ".3"
    }, [
      _createElementVNode("path", {
        "stroke-linejoin": "round",
        d: "M19.726 11.112V7.588L18.228 6.09V1.5a.5.5 0 0 0-.5-.5h-1.996a.5.5 0 0 0-.5.5v4.59l-1.124 1.123-1.123-1.123V1.5a.5.5 0 0 0-.5-.5h-1.997a.5.5 0 0 0-.5.5v4.59L8.865 7.213 7.74 6.09V1.5a.5.5 0 0 0-.5-.5H5.245a.5.5 0 0 0-.5.5v4.59L3.247 7.588v3.524H1.5a.5.5 0 0 0-.5.5v10.984a.5.5 0 0 0 .5.5h19.973a.5.5 0 0 0 .5-.5V11.612a.5.5 0 0 0-.5-.5zM15.98 6.397V2.289h1.498v4.108l1.498 1.498v3.217h-4.494V7.895zm-5.244 0V2.289h1.498v4.108l1.499 1.498v3.217H9.239V7.895zm-6.74 1.498 1.497-1.498V2.289h1.498v4.108L8.49 7.895v3.217H3.996zM1.748 22.439V11.861h19.475v10.575z"
      }),
      _createElementVNode("path", { d: "M13.172 13.943h-3.37c-.724 0-1.312.588-1.312 1.31s.588 1.311 1.311 1.311h3.37c.724 0 1.312-.588 1.312-1.31s-.588-1.311-1.311-1.311Zm0 1.872h-3.37a.561.561 0 1 1 0-1.123h3.37a.561.561 0 1 1 0 1.123Z" })
    ], -1)
  ])))
}
export default { render: render }